export default __webpack_public_path__ + "static/media/all-customers.05f7df71.svg";